import list from './list';
import update from './update';

export default {
  list,
  update,
};
